import { formatToUpperCase } from 'utils/form'

const Ventilation = [
    {
        componentType: "TextField",
        label : "Etiquette : ",
        name : "label",
        placeholder : "Ex. : A1",
    },
    {
        componentType: "NumberField",
        label : "Hauteur au sol : ",
        name : "fromGroundHeight",
        placeholder : "Ex. : 0,95",
        unitLabel : 'm',
    },
    {
        componentType: "TextField",
        format : {formatToUpperCase},
        label : "Plancher ou T.N. de référence : ",
        name : "baseFlooring",
        placeholder : "Ex. : N0",
    },
    {
        componentType: "RadiosField",
        isBoolean: true,
        label : "Occultation existante ",
        name : "hasConcealment",
    },
    {
        componentType: "TextareaField",
        label : "Commentaire sur l'occultation existante : ",
        name : "batardeauComment",
    },
    {
        componentType: "TextareaField",
        label : "Commentaire ouvrant : ",
        name : "comment",
    },
    {
        componentType: "PictureField",
        folderPath : "photos",
        label : "Photo : ",
        name : "photo",
    },
]

export default Ventilation